export const USER_SECURITY_PAGE = {
  ABSOLUTE_PATH: "/settings/security",
  PATH: "/settings/security/*",
  TITLE: "Security",
  ICON: () => null,
};
